import React, { useState } from "react";
import { ChevronDown } from "lucide-react";
import { faqItems } from "../data/mockData";

const FAQ = () => {
  const [openId, setOpenId] = useState(null);
  const toggle = (id) => setOpenId(openId === id ? null : id);

  return (
    <section className="py-28 bg-gray-50/50">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <p className="text-brand-mint-dark text-xs font-bold uppercase tracking-[0.25em] mb-4">
            FAQ
          </p>
          <h2 className="font-heading text-3xl lg:text-4xl text-gray-900 mb-4">
            Frequently Asked Questions
          </h2>
          <p className="text-gray-500 text-[15px]">
            Everything you need to know about our services
          </p>
        </div>

        {/* FAQ Items */}
        <div className="space-y-3">
          {faqItems.map((item) => (
            <div
              key={item.id}
              className="bg-white rounded-xl border border-gray-100 overflow-hidden transition-shadow duration-200 hover:shadow-sm"
            >
              <button
                onClick={() => toggle(item.id)}
                className="w-full flex items-center justify-between p-5 text-left"
              >
                <h3 className="font-semibold text-gray-900 text-[15px] pr-4">
                  {item.question}
                </h3>
                <ChevronDown
                  className={`w-4 h-4 text-brand-mint-dark flex-shrink-0 transition-transform duration-200 ${
                    openId === item.id ? "rotate-180" : ""
                  }`}
                />
              </button>
              <div
                className={`overflow-hidden transition-all duration-200 ${
                  openId === item.id ? "max-h-96 pb-5" : "max-h-0"
                }`}
              >
                <p className="px-5 text-gray-500 text-sm leading-[1.8]">
                  {item.answer}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-14">
          <p className="text-gray-400 text-sm mb-2">Still have questions?</p>
          <a
            href="#contact"
            onClick={(e) => {
              e.preventDefault();
              document.querySelector("#contact")?.scrollIntoView({ behavior: "smooth" });
            }}
            className="text-brand-mint-dark text-sm font-bold hover:text-brand-charcoal transition-colors"
          >
            Get in touch with us →
          </a>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
